/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategoryother2Inputs */

const en_filecategoryother2 = /** @type {(inputs: Filecategoryother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_filecategoryother2 = /** @type {(inputs: Filecategoryother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Filecategoryother2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategoryother2 = /** @type {((inputs?: Filecategoryother2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategoryother2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategoryother2(inputs)
	return pt_filecategoryother2(inputs)
});
export { filecategoryother2 as "fileCategoryOther" }